import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { LabelPrice } from "../LabelPrice/LabelPrice";
import { ELabelPriceVariant } from "../LabelPrice/ELabelPriceVariant";
import { useStyle } from "./style";

interface IParams {
    monthlyTotal: number;
    oneOffTotal: number;
}

export const OrderSummaryTotal = (props: IParams) => {
    const { t } = useTranslation(["cart", "common"]);
    const { classes } = useStyle();

    const { monthlyTotal, oneOffTotal } = props;

    return (
        <div className={classes.orderSummaryTotal}>
            <Typography className={classes.orderSummaryTotalTitle} variant="h5">
                {t("cart:total")}:
            </Typography>
            <LabelPrice label={t("cart:monthly")} price={monthlyTotal} variant={ELabelPriceVariant.ITEM} />
            {oneOffTotal > 0 && (
                <LabelPrice label={t("cart:oneTimeActivation")} price={oneOffTotal} variant={ELabelPriceVariant.ITEM} />
            )}
        </div>
    );
};
